import Env from '../config/envConfig'

import {
  UserLoginRESTServiceApi as UserLoginRESTServiceApiClass,
  SubsidiaryRESTServiceApi as SubsidiaryRESTServiceApiClass,
  AutorisationROApi as AutorisationROApiClass,
  SmPublishConnectApi as SmPublishConnectApiClass,
  UserHasPageApi as UserHasPageApiClass,
  TmpAdminApi as TmpAdminApiClass,
  Configuration,
} from '@professocialApi/professocial-core-frontend-api'
import {
  AboSettingsApi as AboSettingsApiClass,
  Configuration as SMConfiguration,
} from '@3m5/sm_publish-frontend-api'
import customFetchApi from './customFetchApi'
import smModuleFetchApi from './smModuleFetchApi'

const BASE_PATH_API = Env.restBase

export const UserLoginRESTServiceApi = new UserLoginRESTServiceApiClass(new Configuration({
  basePath: BASE_PATH_API,
  fetchApi: customFetchApi(fetch),
}))

export const SubsidiaryRESTServiceApi = new SubsidiaryRESTServiceApiClass(new Configuration({
  basePath: BASE_PATH_API,
  fetchApi: customFetchApi(fetch),
}))

export const AutorisationROApi = new AutorisationROApiClass(new Configuration({
  basePath: BASE_PATH_API,
  fetchApi: customFetchApi(fetch),
}))

export const AboSettingsApi = new AboSettingsApiClass(new SMConfiguration({
  basePath: BASE_PATH_API,
  fetchApi: smModuleFetchApi(fetch),
}))

export const TmpAdminApi = new TmpAdminApiClass(new Configuration({
  basePath: BASE_PATH_API,
  fetchApi: customFetchApi(fetch),
}))

export const SmPublishConnectApi = new SmPublishConnectApiClass(new Configuration({
  basePath: BASE_PATH_API,
  fetchApi: customFetchApi(fetch),
}))

export const UserHasPageApi = new UserHasPageApiClass(new Configuration({
  basePath: BASE_PATH_API,
  fetchApi: customFetchApi(fetch),
}))
